import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import PropTypes from "prop-types";

import Breadcrumbs from "@cayuse/shared-react.components.breadcrumbs";
import Button from "@cayuse/shared-react.components.button";
import SubHeader from "@cayuse/shared-react.components.sub-header";
import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import PageHeader from "components/BudgetBuilder/PageHeader";
import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import ConfirmationModal from "components/ConfirmationModal";
import { clearCurrentVersion, rollbackToCurrentVersion } from "store/actions/budgetBuilder";
import { budgetBuilderSelectors } from "store/selectors";

import styles from "./styles.css";


const SectionHeaderBudgetBuilder = ({ header, breadcrumbs }) => {
	const { dateTimeFormatter } = useTenantFormatter();

	const [ confirmationOpen, setConfirmationOpen ] = useState(false);
	const currentVersion = useSelector(budgetBuilderSelectors.currentVersion);
	const versionText = useMemo(
		() => currentVersion?.date && `Viewing version: ${dateTimeFormatter(currentVersion?.date)}`,
		[ currentVersion, dateTimeFormatter ]
	);
	const onButtonClick = () => setConfirmationOpen(true);

	const onConfirm = () => {
		setConfirmationOpen(false);
		rollbackToCurrentVersion();
	};

	const onCancel = () => {
		setConfirmationOpen(false);
		clearCurrentVersion();
	};

	return (
		<div data-component="SectionHeaderBudgetBuilder">
			<div className={styles.layout}>
				<div>
					{isNonEmptyString(header) && <SubHeader>{header}</SubHeader>}
					{isNonEmptyArray(breadcrumbs)
						? <Breadcrumbs breadcrumbs={breadcrumbs} />
						: breadcrumbs
					}
				</div>
				{currentVersion && <div className={styles.buttonBar}>
					<li className={styles.versionText}>{versionText}</li>
					<li>
						<Button danger onClick={onButtonClick} className={styles.restoreVersionButton}>
							{"Restore this Version"}
						</Button>
					</li>
				</div>}
			</div>
			<div>
				<PageHeader />
			</div>
			<ConfirmationModal
				icon="file-alt"
				title={"On Reverting, Some Recent Changes Will Be Lost"}
				message={"You'll lose some changes that haven't been saved in a version yet. Are you sure you want to revert to a previous version and lose them?"}
				cancelButtonLabel={"Return to Save"}
				confirmButtonLabel={"Revert and Don't Save"}
				onCancel={onCancel}
				onConfirm={onConfirm}
				visible={confirmationOpen}
			/>
		</div>
	);
};

SectionHeaderBudgetBuilder.propTypes = {
	header: PropTypes.string,
	breadcrumbs: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.array
	]),
	buttons: PropTypes.arrayOf(PropTypes.node)
};

export default SectionHeaderBudgetBuilder;
